import { IconContainer } from "@src/components/helper.styled";

const LinkIcon = () => {
	return (
		<IconContainer>
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M8.33325 10.8333C8.69113 11.3118 9.14772 11.7076 9.67204 11.9941C10.1964 12.2806 10.7762 12.4509 11.3721 12.4936C11.9681 12.5363 12.5662 12.4503 13.126 12.2415C13.6858 12.0327 14.1942 11.7059 14.6166 11.2833L17.1166 8.78333C17.8756 7.99749 18.2956 6.94498 18.2861 5.85249C18.2766 4.76 17.8384 3.71495 17.0658 2.94242C16.2933 2.16989 15.2482 1.73168 14.1558 1.72219C13.0633 1.71269 12.0108 2.13267 11.2249 2.89166L9.79159 4.31666"
					stroke="white"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M11.6666 9.16667C11.3087 8.68823 10.8521 8.29235 10.3278 8.00588C9.80347 7.71942 9.22367 7.54907 8.62771 7.50639C8.03176 7.46371 7.4336 7.54969 6.8738 7.75851C6.314 7.96734 5.80566 8.29411 5.38326 8.71667L2.88326 11.2167C2.12426 12.0025 1.70429 13.055 1.71378 14.1475C1.72327 15.24 2.16148 16.285 2.93401 17.0576C3.70655 17.8301 4.7516 18.2683 5.84408 18.2778C6.93657 18.2873 7.98908 17.8673 8.77492 17.1083L10.1999 15.6833"
					stroke="white"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</IconContainer>
	);
};

export default LinkIcon;
